<template>
  <router-view></router-view>
</template>

<script>
export default {
  created() {}
};
</script>

<style>
html, body {
  font-size: 12px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
.scroll-list-wrap {
  height: 100vh;
  overflow: scroll;
}
/* .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 90px;
}

.category-wrapp {
  display: flex;
  align-items: center;
}

.el-upload.el-upload--picture-card {
  margin-bottom: 0 !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  margin: 0;
}

.el-upload-list__item.is-success .el-upload-list__item-status-label {
  opacity: 0;
}
*/

.upload-img {
  width: 146px;
  height: 146px;
  position: relative;
}

.upload-img img {
  width: 146px;
  height: 146px;
}

.upload-img:hover .upload-img_button {
  display: block;
}

.upload-img_button {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 146px;
  height: 146px;
  background-color: rgba(0, 0, 0, 0.4);
  text-align: center;
  line-height: 146px;
  color: #fff;
  cursor: pointer;
}

.table-bottom {
  margin-top: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

